import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import style from "../../../styles/gri/general.module.css";
import { getRowErrorMessages } from "../../../utils/getRowErrorMessage";
import {  validateNumberInput, validatePercentageInput } from "../../../utils/validateFields";
import DeleteRowDialog from "../../../Components/Common/DeleteRowDialog";


const DynamicTable27 = memo(
  ({ inputData, subHeading, tables, setTables, errors, setErrors, data, disabled, hide,  disableColumn
  }) => {
    useEffect(() => {
      setTables(
        inputData?.map((section) => ({
          fieldName: section?.fieldName,
          rows:
            data?.[section?.fieldName]?.length > 0
              ? data[section?.fieldName]
              : [{}],
        }))
      );
      console.log(tables,"h1")

    }, [data]);

    const [fieldToRemove, setFieldToRemove] = React.useState({
      tableIndex: null,
      rowIndex: null,
    });

    

    const [openDialog, setOpenDialog] = React.useState(false);
    const [isFilled, setIsFilled] = useState({});

    const handleAddRow = (tableIndex) => {
      console.log(tables,"h1")
      setTables((prev) => {
        const newTables = [...prev];
        console.log(newTables,"h1")
        newTables[tableIndex]?.rows?.push({});
        return newTables;
      });
    };

    const handleRemoveRow = (tableIndex, rowIndex) => {
      setTables((prev) => {
        const newTables = [...prev];
        if (
          Object.values(newTables[tableIndex].rows[rowIndex] || {}).some((val) => val)
        ) {
          setOpenDialog(true);
          setFieldToRemove({ tableIndex, rowIndex });
          return newTables;
        }

        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    };

    const cancelRemoveRow = () => {
      setOpenDialog(false);
    };

    const confirmRemoveRow = () => {
      if (fieldToRemove) {
        const { tableIndex, rowIndex } = fieldToRemove;
        setTables((prev) => {
          const newTables = [...prev];
          newTables[tableIndex].rows.splice(rowIndex, 1);
          return newTables;
        });
      }
      setOpenDialog(false);
    };

    // const handleInputChange = (
    //   tableIndex,
    //   rowIndex,
    //   fieldName,
    //   value,
    //   type,
    //   options
    // ) => {
    //   if (type === "percentage" && !validatePercentageInput(value)) return;
    //   if (type === "number" && !validateNumberInput(value)) return;

    //   const updatedTables = [...tables];

    //   let value2 = options?.includes("Select All")
    //     ? value?.includes("Select All")
    //       ? value?.length < options?.length && value?.length !== 1
    //         ? value?.[value?.length - 1] === "Select All"
    //           ? options
    //           : value?.filter((el) => el !== "Select All")
    //         : options
    //       : value?.length ===
    //         options?.filter((el) => el !== "Select All").length
    //       ? []
    //       : value
    //     : value;

    //   updatedTables[tableIndex].rows[rowIndex][fieldName] = value2;

    //   const updatedErrors = { ...errors };
    //   if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
    //     delete updatedErrors[tableIndex][rowIndex][fieldName];
    //     if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
    //       delete updatedErrors[tableIndex][rowIndex];
    //     }
    //     if (Object.keys(updatedErrors[tableIndex]).length === 0) {
    //       delete updatedErrors[tableIndex];
    //     }
    //   }
    //   console.log(tables);
    //   setErrors(updatedErrors);
    //   setTables(updatedTables);
    //   checkIfAdded();
    // };

    // useEffect(() => {
    //   checkIfAdded();
    // }, [tables, inputData]); // Run only when tables or inputData change


    const handleInputChange = (
        tableIndex,
        rowIndex,
        fieldName,
        value,
        type,
        options
      ) => {
        if (type === "percentage" && !validatePercentageInput(value)) return;
        if (type === "number" && !validateNumberInput(value)) return;
      
        const updatedTables = [...tables];
      
        let value2 = options?.includes("Select All")
          ? value?.includes("Select All")
            ? value?.length < options?.length && value?.length !== 1
              ? value?.[value?.length - 1] === "Select All"
                ? options
                : value?.filter((el) => el !== "Select All")
              : options
            : value?.length ===
              options?.filter((el) => el !== "Select All").length
            ? []
            : value
          : value;
      
        updatedTables[tableIndex].rows[rowIndex][fieldName] = value2;
      
        // Calculate total employees if any of the relevant fields change
        if (
          fieldName === "maleEmployees" ||
          fieldName === "femaleEmployees" ||
          fieldName === "other" ||
          fieldName === "notDisclosed"
        ) {
          const maleEmployees = parseFloat(updatedTables[tableIndex].rows[rowIndex].maleEmployees) || 0;
          const femaleEmployees = parseFloat(updatedTables[tableIndex].rows[rowIndex].femaleEmployees) || 0;
          const other = parseFloat(updatedTables[tableIndex].rows[rowIndex].other) || 0;
          const notDisclosed = parseFloat(updatedTables[tableIndex].rows[rowIndex].notDisclosed) || 0;
      
          const totalEmployees = maleEmployees + femaleEmployees + other + notDisclosed;
          updatedTables[tableIndex].rows[rowIndex].totalEmployees = totalEmployees;
        }
      
        const updatedErrors = { ...errors };
        if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
          delete updatedErrors[tableIndex][rowIndex][fieldName];
          if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
            delete updatedErrors[tableIndex][rowIndex];
          }
          if (Object.keys(updatedErrors[tableIndex]).length === 0) {
            delete updatedErrors[tableIndex];
          }
        }
      
        setErrors(updatedErrors);
        setTables(updatedTables);
        checkIfAdded();
      };

    const checkIfAdded = () => {
      tables.forEach((table, tableIndex) => {
        const rows = table?.rows || [];
        const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; // Ensure lastRow is an object
        const filteredLastRow = Object.fromEntries(
          Object.entries(lastRow).filter(([key]) => key !== "_id")
        );

        const optionalLength=inputData?.[tableIndex]?.fields?.filter(el=>el?.optional)?.length;
        console.log(optionalLength,"option")
        // Check if lastRow is fully filled
        const isComplete =
          Object.keys(filteredLastRow).length >=
            (inputData?.[tableIndex]?.fields?.length-optionalLength || 0) &&
          Object.values(filteredLastRow)?.every(
            (val) =>
              val !== undefined &&
              val !== "" &&
              val !== null &&
              val?.length !== 0
          );
        console.log("complte", lastRow, isComplete);
        setIsFilled((prevState) => ({
          ...prevState,
          [tableIndex]: !isComplete, // true if incomplete, false if fully filled
        }));
      });
    };

    useEffect(() => {
      checkIfAdded();
    }, [tables, inputData]); // Run only when tables or inputData change

    return (
      <Box sx={{ mt: "2rem" }}>
        <DeleteRowDialog
          {...{ openDialog, cancelRemoveRow, confirmRemoveRow }}
        />
        {subHeading && <p className={style.subHeading}>{subHeading}</p>}
        {inputData?.map((section, tableIndex) => (
          <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                textIndent: "-1rem",
                paddingLeft: "1rem",
              }}
              gutterBottom
            >
              {section.title}
            </Typography>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "10px",
                ml: 2,
                width: "98.5%",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                        textAlign: "center",
                      }}
                    >
                      S. No.
                    </TableCell>
                    {section?.fields?.map((field) => (
                      <TableCell
                        key={field?.fieldName}
                        style={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: field.width,
                          maxWidth: field.width,
                        }}
                      >
                        {field?.title}
                      </TableCell>
                    ))}
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "1rem",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                    console.log(row, "checking row");
                    return (
                      <TableRow
                        key={rowIndex}
                        sx={{
                          "& > th": {
                            color: "white",
                            fontWeight: "bold",
                            py: "0.5rem",
                            px: "0.5rem",
                            border: "1px solid rgba(224, 224, 224, 1)",
                            height: "auto",
                          },
                        }}
                      >
                        <TableCell sx={{ textAlign: "center", width: "8%" }}>
                          {rowIndex + 1}.
                        </TableCell>
                        {section?.fields?.map((field) => (
                          <TableCell
                            key={field?.fieldName}
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              width: field.width,
                              maxWidth: field.width,
                              height: "auto",
                            }}
                          >
                            {field.type === "select" ? (
                              <Select
                                multiple={field?.multiselect}
                                multiline
                                minRows={1}
                                placeholder="Select"
                                disabled={disabled}
                                value={
                                  field?.multiselect
                                    ? row[field?.fieldName] || [] // Ensure array for multiselect
                                    : row[field?.fieldName] || "" // Ensure string for single select
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type,
                                    field.options
                                  )
                                }
                                displayEmpty
                                fullWidth
                                size="small"
                                sx={{
                                  border: "none",
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                  },
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      border: "none",
                                    },
                                }}
                                renderValue={(selected) => {
                                  if (selected?.includes("Select All")) {
                                    return selected
                                      ?.filter(
                                        (option) => option !== "Select All"
                                      )
                                      ?.join(", "); // Display custom text when "Select All" is selected
                                  }
                                  return field?.multiselect && 
                                    selected?.length > 0
                                    ? selected?.join(", ")
                                    : selected || field.placeholder || "Select";
                                }}
                              >
                                <MenuItem value={""} disabled>
                                  {field.placeholder || "Select"}
                                </MenuItem>
                                {field.options?.map((option, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={option?.name || option} // Ensure the `value` matches the `row[field.fieldName]`
                                  >
                                    {field.multiselect ? (
                                      <>
                                        <Checkbox
                                          checked={
                                            row[field.fieldName]?.includes(
                                              option?.name || option
                                            ) || false
                                          } // Check if the option is selected
                                          size="small"
                                          disabled={disabled}
                                        />
                                        {option?.name || option}
                                      </>
                                    ) : (
                                      option?.name || option
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            ) : field.type === "radio" ? (
                              // console.log(row,row[field.fieldName],"Checking...")
                              <Box sx={{ display: "flex" }}>
                                <FormControl sx={{ my: 1, display: "flex" }}>
                                  <RadioGroup
                                    row
                                    value={row[field.fieldName] || "Yes"}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      handleInputChange(
                                        tableIndex,
                                        rowIndex,
                                        field.fieldName,
                                        e.target.value,
                                        field.type
                                      )
                                    }
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      control={<Radio />}
                                      label="Yes"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio />}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            ) : (
                              <TextField
                                placeholder={field.placeholder}
                                type={field.type}
                                value={row[field.fieldName] || ""}
                                disabled={field.fieldName===disableColumn || disabled}
                                onChange={(e) =>
                                  handleInputChange(
                                    tableIndex,
                                    rowIndex,
                                    field.fieldName,
                                    e.target.value,
                                    field.type
                                  )
                                }
                                multiline
                                minRows={1}
                                sx={{
                                  width: "100%",
                                  py: "0.5rem",
                                  "& .MuiInputBase-root": {
                                    overflowY: "auto",
                                    cursor: "default", // default cursor
                                  },
                                  "& .MuiInputBase-root:hover": {
                                    cursor: "pointer", // pointer cursor on hover
                                  },
                                }}
                                size="small"
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            )}
                          </TableCell>
                        ))}

                        <TableCell sx={{ width: "8%" }}>
                          <IconButton
                            disabled={tables[tableIndex]?.rows?.length === 1 || disabled}
                            onClick={() =>
                              handleRemoveRow(tableIndex, rowIndex)
                            }
                            color="error"
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 1, ml: 3 }}>
              {Object.keys(errors).length > 0 &&
                getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                  (errorMessage, idx) => (
                    <p
                      key={idx}
                      color="error"
                      variant="caption"
                      style={{
                        lineHeight: "1.2",
                        margin: "2px 0",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )
                )}
            </Box>
            {/* Add row button */}
              {!hide &&
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            
              <Button
                disabled={isFilled?.[tableIndex] || disabled}
                endIcon={<Add />}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
            }
          </div>
        ))}
      </Box>
    );
  }
);

export default DynamicTable27;
